import React from 'react'
import Icon from '../misc/Icons'
import QuestionCountBadge from '../uiKit/QuestionCountBadge'
import SearchPathBreadcrumb from './SearchPathBreadcrumb'
import LocalBadge from './LocalBadge'
import { formatDate } from '../../utils/formatDate'
import { getRepoforId } from '../../utils/getRepoforId'

class SearchResultsCard extends React.Component {
  render() {
    const {
      title, item, question, set, onClick, onDoubleClick,
    } = this.props

    let inSharedRepo = false
    let inPublicConsumerRepo = false
    let inPublicAuthorRepo = false
    if (item.repo) {
      const parentRepo = getRepoforId(item.repo)
      if (parentRepo) {
        inSharedRepo = parentRepo.shared
        inPublicConsumerRepo = parentRepo.role === 'consumer'
        inPublicAuthorRepo = parentRepo.role === 'author'
      }
    }

    const modifier = set ? 'set' : 'question'
    const questionCount = set && Array.isArray(item.questions) ? item.questions.length : undefined

    return (
      <div
        className={`searchResultsRow searchResultsRow--${modifier}`}
        role='button'
        tabIndex={0}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
      >
        <div className='searchResultsRow-icon'>
          {set ? (
            <QuestionCountBadge
              color='blueLight'
              size='medium'
              questionCount={questionCount}
            />
          ) : (
            <QuestionCountBadge color='blueLight' size='medium' questionCount='–' />
          )}
        </div>
        <div className='searchResultsRow-body'>
          <div className='searchResultsRow-title'>
            <span className='searchResultsRow-title-text'>{title}</span>
            {inSharedRepo && <Icon name='shared' />}
            {inPublicConsumerRepo && <Icon name='globe-shared' />}
            {!set && !question && inPublicAuthorRepo && <Icon name='globe-shared-author' />}
            <LocalBadge hit={item} />
          </div>
          <SearchPathBreadcrumb item={item} classPrefix='searchResultsRow-path' linked />
          <div className='searchResultsRow-meta'>
            <span className='searchResultsRow-meta-edited'>
              {'Edited '}
              {formatDate(item.clientModified)}
            </span>
          </div>
        </div>
      </div>
    )
  }
}

export default SearchResultsCard
